import { Typography } from "@mui/material";

interface TypographyProps extends React.ComponentProps<typeof Typography> {
  isTitle?: boolean;
  marginLeft?: string;
  hasLeftBorder?: boolean;
  component?: React.ElementType;

}

export const ByzMuiTypography = ({
  isTitle = false,
  hasLeftBorder,
  marginLeft,
  sx,
  textAlign,
  fontWeight,
  component,
  ...rest
}: TypographyProps) => {
  return (
    <Typography
      {...rest}
      component={component || "span"}
      sx={{
        display: "flex",
        textAlign: !isTitle ? "left" : textAlign || "center",
        marginLeft: isTitle ? "0px" : marginLeft || "16px",
        fontWeight: isTitle ? 700 : fontWeight || 500,
        fontSize: isTitle ? 16 : 14,
        borderLeft: hasLeftBorder ? "2px solid #ccc" : undefined,
        paddingLeft: hasLeftBorder ? "8px" : undefined,
        whiteSpace: "pre-line",
        ...sx,
      }}
    />
  );
};

export default ByzMuiTypography;
